<template>
        <div class="container mw-1136">
            <div class="row text-center">
                <div class="col-10 col-md-8 mx-auto">
                    <wide-box class="box-score">
                        <h4 class="text-uppercase fw-bold mb-3">Błąd 404</h4>
                        <div class="f16 mb-5">Niestety nie udało się znaleźć tej strony.</div>
                        <a href="/" class="btn">Strona główna</a>
                    </wide-box>
                </div>
            </div>
        </div>
</template>

<script>
import WideBox from "@/components/WideBox";
export default {
    name: "ErrorPage",
    components: {WideBox},
}
</script>

<style scoped lang="scss">

</style>
